import { apiService } from './apiService';

export const fetchStationDetails = async (uuid) => {
    try {
        const response = await fetch(`https://ims.radiolize.com/api/v1/station/details/${uuid}`);
        if (!response.ok) throw new Error('Failed to fetch station details');
        return await response.json();
    } catch (error) {
        console.error('Error fetching station details:', error);
        throw error;
    }
};

export const generateStreamUrls = (stationDetails) => {
    if (!stationDetails?.stationUrl || !stationDetails?.azuracastId) {
        throw new Error('Invalid station details');
    }

    const stationUrl = stationDetails.stationUrl.replace(',', '.');
    const azuracastId = stationDetails.azuracastId;

    return {
        apiUrl: `https://${stationUrl}/api/nowplaying/${azuracastId}`,
        streamUrl: null // Will be set after fetching mount details
    };
};

export const fetchAndSetStreamUrl = async (apiUrl) => {
    try {
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error('Failed to fetch stream details');
        const data = await response.json();

        // Get the first mount's URL
        const mount = data.station?.mounts?.[0];
        if (!mount?.url) {
            throw new Error('No valid mount found');
        }

        return mount.url;
    } catch (error) {
        console.error('Error fetching stream URL:', error);
        throw error;
    }
}; 